<template>
  <!-- 套利订货明细 -->
  <div v-show="isShow">
    <div class="report_title">
      <label class="report-line" />
      <span class="report-title">套利订货明细</span>
      <exportConfig
        :all-head="allHead"
        :header-name="headerName"
        :width="'200'"
      />
    </div>
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        fixed
        prop="signHoldDate"
        label="成交日期"
      />
      <af-table-column
        fixed
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="buyHoldAmount"
        label="采购数量(笔)"
      />
      <af-table-column
        prop="sellHoldAmount"
        label="销售数量(笔)"
      />
      <af-table-column
        prop="businessPriceMargin"
        label="成交价差"
      />
      <af-table-column
        prop="frozenBailBalance"
        label="基本担保履约资金(订货)"
      />
      <af-table-column
        prop="holdGainLoss"
        label="补充担保履约资金"
      />
    </el-table>
    <MoreData
      :all-data="allData"
      :table-data.sync="tableData"
    />
    <br><br>
  </div>
</template>

<script>
import api from '@/api'
import MoreData from '@/components/more-data'
import exportConfig from '@/components/exportConfig'

export default {
  name: 'ArbitrageOrderDetail',
  components: {
    MoreData,
    exportConfig,
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      allHead: [{
        fieldLabel: '客户号',
        excelColumn: 'tradeUserAccount'
      },
      {
        fieldLabel: '成交日期',
        excelColumn: 'signHoldDate'
      },
      {
        fieldLabel: '购销计划',
        excelColumn: 'goodsCode'
      },
      {
        fieldLabel: '采购数量(笔)',
        excelColumn: 'buyHoldAmount'
      },
      {
        fieldLabel: '销售数量(笔)',
        excelColumn: 'sellHoldAmount'
      },
      {
        fieldLabel: '成交价差',
        excelColumn: 'businessPriceMargin'
      },
      {
        fieldLabel: '基本担保履约资金(订货)',
        excelColumn: 'frozenBailBalance'
      },
      {
        fieldLabel: '补充担保履约资金',
        excelColumn: 'holdGainLoss'
      },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      isShow: false,

      tableData: [], // 表格数据
      allData: [],
      headerName: '购销计划一览表_套利订货明细',
    }
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.tradingDay = param.date ? this.$dayjs(this.query.date).format('YYYYMMDD')
        : '' // 默认时间，不附带时间将会返回所有数据，而且连分页都没做
      let res = await api.spotPurchaseSaleInquiry.ArbitrageOrderDetail(param)
      this.allData = res.data || []
      this.isShow = !(this.allData.length === 0 || (this.allData.length === 1 && this.allData[0]['tradeUserAccount'] === '合计'))
    },
  }
}

</script>

<style lang="scss" scoped>
  ::v-deep .el-table__fixed .el-table__fixed-body-wrapper tbody>tr:last-child {
    td:nth-child(3) div {
      display: none;
    }
  }

</style>
